export class NavigationConstants {

    static PAGE = 'NXI_NAVIGATION.';
    static MOD_STOCK_SCREENER = 'FIVE_FOUR_TWO';
    static MOD_ETF_SCREENER = 'FIVE_THREE_FIVE';
    static MOD_MUTUAL_FUND_SCREENER = 'FIVE_FOUR_THREE';
    static propertyMap = new Map([
    [ 'DAV' , new Map([['Advisor' , 'NXI_NAVIGATION.ADVISORHOMEDAV']])],
    [ '30A' , new Map([['Advisor' , 'Resource Center']])],
    [ 'LBG' , new Map([['Advisor' , 'NXI_NAVIGATION.ADVISOR']])]
    ]);

    static entitlementsDetails = [
        {  "entitlements": "STOCK_TRADING",  "url": "stocktrading", "isEntitled": false },
        {  "entitlements": "MUTUAL_FUND_TRADING",  "url": "mutualfundtrading", "isEntitled": false },
        {  "entitlements": "OPTIONS_TRADING",  "url": "optiontrading","isEntitled": false },
        {  "entitlements": "TRADING_529_FUND",  "url": "trading529", "isEntitled": false },
        {  "entitlements": "XTND_HOURS",  "url": "extendedhours", "isEntitled": false }
    ]
}
export class CustomHeader {
    static propertyMap = new Map([
       
        [ '5QH', new Map([[ 'site_specific_resources', 'external_links']])],
        [ '56M', new Map([[ 'site_specific_resources', 'external_links']])],
        [ 'NSC', new Map([[ 'site_specific_resources', 'external_links']])],
        [ '44A', new Map([[ 'site_specific_resources', 'external_links']])],
        [ 'PEC', new Map([[ 'site_specific_resources', 'external_links']])],
        [ 'VCS', new Map([[ 'site_specific_resources', 'victory_resources_title']])]
       
    ]);
}

export class AboutUsDialogHeader {
    static propertyMap = new Map([
       
        [ 'troweprice', new Map([[ 'about_us', 'resource_center']])]
    ]);
}
